import { API } from "../auth/authApi";

API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");

  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }

  return req;
});

export const fetchSessionsApi = ({
  page = 1,
  limit = 10,
  search = "",
  locationId = ""
}) => {
  let url = `/session?page=${page}&limit=${limit}&search=${search}`;

  if (locationId) {
    url += `&locationId=${locationId}`;
  }

  return API.get(url);
};

export const createSessionApi = (data) => API.post("/session", data);

export const deleteSessionApi = (id) => API.delete(`/session/${id}`);

export const updateSessionApi = (id, data) => API.put(`/session/${id}`, data);

export const fetchDeletedSessionsApi = () => API.get("/session/deleted");

export const restoreSessionApi = (id) => API.post(`/session/restore/${id}`);

export const permanentDeleteSessionApi = (id) =>
  API.delete(`/session/permanent/${id}`);

export const getSessionRatingsApi = (sessionId) =>
  API.get(`/session/${sessionId}/rating`);

export const getSessionNotesApi = (sessionId) =>
  API.get(`/session/${sessionId}/note`);